import type { ReactNode } from "react";
import { cn } from "@/utils/utils";

export interface TPageHeaderProps {
    title: string;
    description?: string;
    icon?: ReactNode;
    actions?: ReactNode;
    className?: string;
}

export function PageHeader({ title, description, icon, actions, className }: TPageHeaderProps) {
    return (
        <div className={cn("flex items-start justify-between", className)}>
            <div className="flex items-center gap-3">
                {icon && <div className="text-primary">{icon}</div>}
                <div>
                    <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
                    {description && (
                        <p className="mt-1 text-sm text-muted-foreground">{description}</p>
                    )}
                </div>
            </div>
            {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
    );
}
